import { OrganizerInstitution } from "./institution/organizer";
import {
  DevelopmentProgram,
  FormDevelopmentCompetencyGroupClassifier,
  FormMandatoryTopicClassifier,
  LearningProgram,
  ProgramType,
} from "./program";
import { CertificateOther } from "./certificate";
import { ClassifierValue } from "./classifier";
import { Import } from "./import";

export type Event = {
  id: number;
  price: string;
  name: string;
  startDate: string;
  endDate: string;
  description: string;
  isRemote: boolean;
  registrationInfo: string | null;
  registrationDate: string;
  status: EventStatus;
  international: boolean;
  eventHours: number;
  eventMandatoryHours: number;
  identification: string;
  isClosed: boolean;
  ended: boolean;
  place: string | null;
  city?: EventCity | null;
  program: DevelopmentProgram | LearningProgram;
  organizerInstitution: OrganizerInstitution;
  specialistUsers?: EventParticipant[];
  specialistUsersCount: number;
  certificates: CertificateOther[];
  website: string;
  updatedAt: string;
  programFormValueName: string;
  otherTargetedAudienceClassifiers?: ClassifierValue[];
  latestEventSpecialistUsersImport?: Import;
};

export type EventCity = {
  id: string;
  valueName: string;
};

export type FormEvent = {
  program: number;
  programType: ProgramType;
  startDate: string;
  endDate: string;
  description: string;
  isRemote?: boolean;
  registrationInfo?: string;
  place?: string;
  city?: string | null;
  website?: string | null;
  duration?: number | Number;
  price: number;
  targetedProgramClassifiers?: string[];
  targetedAudienceClassifiers?: string[];
  mandatoryTopicClassifiers?: FormMandatoryTopicClassifier[];
  eventForm?: string; // only by development program
  international?: boolean; // only by development program
  developmentCompetencyGroupClassifiers?: FormDevelopmentCompetencyGroupClassifier[]; //only by development program
  acquiredCompetencyClassifiers?: string[]; // only by learning program
  programFormClassifierName?: string | null;
  otherTargetedAudienceClassifierIds?: string[] | null;
};

export type BodyEvent = {
  international?: boolean;
  isRemote?: boolean;
  registrationInfo?: string;
  price: string;
  place?: string;
  city?: string | null;
  endDate: string;
  startDate: string;
  program: number;
  website?: string;
  description: string;
};

export enum EventStatus {
  CREATED = "CREATED",
  CANCELED = "CANCELED",
  FINISHED = "FINISHED",
  FINISHED_WITHOUT_SPECIALISTS = "FINISHED_WITHOUT_SPECIALISTS",
}

export type EventsFilters = {
  startDate: string | null;
  endDate: string | null;
  name: string | null;
  organizerId: number | null;
  identification: string | null;
  eventHours: number | null;
  programType: ProgramType | null;
  otherTargetedAudienceClassifierId: string | null;
  targetedAudienceClassifierId: string | null;
};

export type PublicEventsFilters = {
  name: string | null;
  startDate: string | null;
  endDate: string | null;
  organizerInstitution: string | null;
  developmentCompetencyGroupClassifier: string | null;
  programType: ProgramType | null;
  eventHours: number | null;
  review: number | null;
  price: number | null;
  otherTargetedAudienceClassifierId: string | null;
  targetedAudienceClassifierId: string | null;
  city: string | null;
  isRemote: boolean | null;
  includeExpired: boolean | null;
};

export type EventParticipant = {
  id: number;
  firstName: string;
  lastName: string;
  code: number;
};

export type FormEventParticipant = Omit<EventParticipant, "id">;

export type EventVersion = {
  id: number;
  data: Omit<Event, "program"> & Partial<Pick<Event, "program">>;
  createdAt: string;
  program: DevelopmentProgram | LearningProgram;
};
